module.exports = __webpack_public_path__ + "img/5_2023_07_19.c5948a7f.jpg";